import React, { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FaBuilding } from "react-icons/fa";
import { MdFormatListBulleted } from "react-icons/md";
import CrmListPage from "components/app/crm/shared/CrmListPage";
import { getAllDepartments, exportDepartments } from "redux/organization/departmentSlice";
import { getAllSites } from "redux/organization/siteSlice";

const columns = [
  { headerName: "ID#",    field: "id",          minWidth: 100, sortable: false },
  { headerName: "Name",   field: "name",        minWidth: 220, sortable: false },
  { headerName: "Parent", field: "parent_name", minWidth: 200, sortable: false },
  { headerName: "Site",   field: "site_name",   minWidth: 200, sortable: false }
];

const TABS = [{ key: "all", label: "All", Icon: MdFormatListBulleted, thunk: getAllDepartments, dataKey: "allData" }];

const DepartmentListPage = () => {
  const dispatch = useDispatch();
  const { data: siteData = [] } = useSelector((s) => s.organization_site.allData);

  useEffect(() => { dispatch(getAllSites()); }, [dispatch]);

  const advancedFields = useMemo(() => [
    { key: "name", label: "Name", type: "text",        paramKey: "name_cont",   tagName: "Name" },
    { key: "site", label: "Site", type: "multiselect", options: siteData.map((s) => ({ value: s.id, label: s.name })), paramKey: "site_id_in", tagName: "Site" }
  ], [siteData]);

  return (
    <CrmListPage
      title="Departments"
      subtitle="Organization department structure."
      Icon={FaBuilding}
      reducerSelector={(s) => s.organization_department}
      tabs={TABS}
      columns={columns}
      searchParamKey="name_cont"
      searchPlaceholder="Department name..."
      advancedFields={advancedFields}
      advancedTitle="Filters for departments"
      exportThunk={exportDepartments}
    />
  );
};

export default DepartmentListPage;
